import * as Yup from 'yup';
import { checkBoxRequried, emailRequired, nameRequired, passwordRequired, stringRequired } from '.';

export const inviteCustomerSchema = Yup.object({
    first_name: nameRequired,
    last_name: nameRequired,
    email: emailRequired,
    phone_number: stringRequired,
    is_primary: checkBoxRequried
});

export const setPasswordSchema = Yup.object({
    password: passwordRequired,
    confirm_password: Yup.string()
        .oneOf([Yup.ref('password')], 'Passwords must match')
        .required('Confirm Password is required')
});

export const personalDetailsSchema = Yup.object({
    first_name: nameRequired,
    last_name: nameRequired,
    phone_number: stringRequired
});